// components/PreviewModal.jsx

import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

import { formatFileSize } from '../../../components/bids/utils/bidWizardHelpers';

import { useDocumentPreview } from '../../../hooks/document/useDocument';

const PreviewModal = ({ documentId, documents, onClose }) => {
  const { data: previewData, isLoading, error } = useDocumentPreview(documentId, true);
  
  const signedUrl = previewData?.signedUrl;
  const document = documents.find(d => d.id === documentId);

  return (
    <div className="fixed inset-0 bg-black z-50 flex flex-col">
      {/* Modal Header */}
      <div className="flex items-center justify-between px-6 py-4 bg-slate-900 border-b border-slate-700">
        <div className="flex items-center gap-3">
          <div className="text-2xl">📄</div>
          <div>
            <h3 className="font-semibold text-white">
              {document?.display_name || document?.original_name || 'Document Preview'}
            </h3>
            {document && (
              <p className="text-sm text-slate-400">
                {formatFileSize(document.size)} • PDF • {document.category}
              </p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onClose}
            className="p-2 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Modal Body - Full Screen */}
      <div className="flex-1 overflow-hidden bg-slate-900">
        {isLoading && (
          <div className="flex items-center justify-center h-full">
            <div className="text-center">
              <div className="animate-spin w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full mx-auto mb-4"></div>
              <p className="text-white">Loading preview...</p>
            </div>
          </div>
        )}

        {error && (
          <div className="flex items-center justify-center h-full p-12">
            <div className="text-center">
              <ExclamationCircleIcon className="w-24 h-24 text-red-600 mx-auto mb-4" />
              <h4 className="text-lg font-semibold text-white mb-2">
                Preview Failed
              </h4>
              <p className="text-slate-400 mb-4">
                {error.message}
              </p>
            </div>
          </div>
        )}

        {signedUrl && !isLoading && (
          <iframe
            src={signedUrl}
            className="w-full h-full"
            title="Document Preview"
          />
        )}
      </div>
    </div>
  );
};

export default PreviewModal;